import React from 'react';
import { ProviderMatchTraining } from '@kyruus/types';

import { ExpertiseEntryContainer } from './styles';
import { insertBetweenItems } from '../../lib/utils';

interface EducationEntryProps {
  training: ProviderMatchTraining;
}

const EducationEntry = ({
  training
}: EducationEntryProps): React.ReactElement | null => {
  if (!training) {
    return null;
  }

  const { name, type, field_of_study, degree, graduation_year } = training;
  const typeMarkup = type ? (
    <span itemProp="credentialCategory" key="credentialCategory">
      {`${type}: `}
    </span>
  ) : null;
  const fieldOfStudyMarkup = field_of_study ? (
    <span itemProp="about" key="about">
      {field_of_study}
    </span>
  ) : null;
  const degreeMarkup = degree ? (
    <span itemProp="educationalLevel" key="educationalLevel">
      {degree}
    </span>
  ) : null;
  const graduationYearMarkup = graduation_year ? (
    <span itemProp="dateCreated" key="dateCreated">
      {graduation_year}
    </span>
  ) : null;
  const nameMarkup = name ? (
    <span itemProp="recognizedBy" key="recognizedBy">
      {name}
    </span>
  ) : null;

  return (
    <ExpertiseEntryContainer
      itemProp="hasCredential"
      itemScope={true}
      itemType="https://schema.org/EducationalOccupationalCredential"
    >
      {typeMarkup}
      {insertBetweenItems(
        [
          nameMarkup,
          fieldOfStudyMarkup,
          degreeMarkup,
          graduationYearMarkup
        ].filter(Boolean),
        ', '
      )}
    </ExpertiseEntryContainer>
  );
};

export default EducationEntry;
